import React, { useCallback } from "react"
import { Col, Row } from "react-bootstrap"
import { State } from "@hookstate/core"
import { Validation } from "@hookstate/validation"
import { ProductTypes, useProductPropertiesDataState } from "../../globalStates/ProductPropertiesState"
import { getElementFieldValue, makeValidationHandler } from '../../globalStates/utils'
import { Product, Properties } from "../../globalStates/ExhibitorDataState"
import { useLanguageState } from "../../globalStates/LanguageState"
import SelectField from '../../components/Field/Select'
import ProductInformation from "./ProductInformation"

function parseProperties(properties: any): Properties[] {
    return properties?.map((property: any) => ({
        id: property.id.get(),
        name: property.name.get(),
        nameDe: property.nameDe.get(),
        productType: property.productType.get(),
        type: property.type.get(),
        unit: property.unit.get(),
        unitDe: property.unitDe.get(),
        val: property.val.get()
    }))
}

function findPropertiesByTypeId(properties: State<ProductTypes>, selectedProductType: string) {
    return properties.properties.find(({ id }) => id.get() === selectedProductType)
}

function getProductProperties(properties: State<ProductTypes>, productPropertyState: State<Product>) {
    const findedProperties = findPropertiesByTypeId(properties, productPropertyState.type.get())
    return parseProperties(findedProperties?.properties)
}

function checkPropertiesLenght(productPropertyState: State<Product>) {
    return productPropertyState.properties.get().length !== 0 ? prompt("Do you want change properties?", "Current properties will be deleted!") : ""
}

interface ProductInformationContainsProps {
    id: string
    productPropertyState: State<Product, Validation>
    propertiesOptions: any
}

const AddProductProperty: React.FC<ProductInformationContainsProps> = ({ id, productPropertyState, propertiesOptions }) => {

    const branding = useLanguageState().getStrings()

    const productPropertiesDataState = useProductPropertiesDataState()
    const properties = productPropertiesDataState.getProductTypes()

    const onChangeProductProperties = useCallback(() => {
        productPropertyState.type.set(productPropertyState.type.get())

        let removeProperties = checkPropertiesLenght(productPropertyState)
        if ((productPropertyState.type.get()) && (removeProperties != null)) {
            productPropertyState.properties.set([])
            productPropertyState.properties.set(() => getProductProperties(properties, productPropertyState))
        }
    }, [productPropertyState, properties])

    return (
        <>
            <Row>
                <Col>
                    <SelectField
                        id={id}
                        name="type"
                        label={branding.configuration.productsPage.sctProduct.productType}
                        placeholder={branding.configuration.productsPage.sctProduct.productTypePlaceholder}
                        options={propertiesOptions}
                        validate={makeValidationHandler(productPropertyState, 'type')}
                        value={getElementFieldValue(productPropertyState, "type")}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            productPropertyState["type"].set(event.target.value)
                            onChangeProductProperties()
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    {productPropertyState?.properties.map((property, index) => (
                        <ProductInformation
                            key={index}
                            index={index}
                            property={property}
                        />
                    ))}
                </Col>
            </Row>
        </>
    )
}

export default AddProductProperty
